import React, { useState, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components'
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'
import ReactLoading from 'react-loading';

import dayjs from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';

import { ScatterChart, Scatter, XAxis, YAxis, Legend, ZAxis, Tooltip, ResponsiveContainer } from 'recharts';

import optc from '../optc.json'

import { useTranslation } from "react-i18next";

import {
  getAllAgencies,
  getUser,
  getTripsInfo,
  getUserAgency,
  getCancelledTrips,
  getCancelledInt
} from '../API';

const Styles = styled.div
  `
  padding: 1rem;

  .pagination {
    padding: 0.5rem;
  }

  th

  td { background-color: white; }

  td:nth-child(1) { 
    background: #79508f ;
    color: white }
  
`

function Table({ columns, data }) {

  const [t] = useTranslation('common');

  const [selectedRow, setSelectedRow] = useState(-1);

  const [filterInput, setFilterInput] = useState("");

  const handleFilterChange = e => {
    const value = e.target.value || undefined;
    setFilter("route_id", value); // Update this specific field
    setFilterInput(value);
  };

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active pagconst [cellValue, setCellValue] = useState('');e

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },

      sortTypes: {
        custom: (rowA, rowB, columnId) => {
          const a = rowA.values[columnId];
          const b = rowB.values[columnId];

          if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
          }
          return a.localeCompare(b);
        }
      },
    },
    useFilters,
    useSortBy,
    usePagination,
  )

  const handleRowHover = (e) => {
    setSelectedRow(e.id);
  }

  const handleMouseOut = () => {
    setSelectedRow(-1);
  }

  // const handleCellClick = (e) => {

  // }

  // Render the UI for your table
  return (

    <>
      {headerGroups[0].headers.find((e) => { return e.id == 'route_id' }) ? <div className="row">
        <div className="col-12 text-center">
          <input
            value={filterInput}
            onChange={handleFilterChange}
            placeholder={t("routeoperation.find")}
          />
        </div>
      </div > : ''}
      <table className="table" {...getTableProps()}>
        <thead style={{ textAlign: 'center' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {

            prepareRow(row);

            return (
              <tr
                onMouseMove={(e) => handleRowHover(row)} onMouseOut={() => handleMouseOut()}
                {...row.getRowProps()}
              >
                {row.cells.map(cell => {
                  return <td
                    style={{ backgroundColor: row.id == selectedRow && cell.column.Header !== 'Ligne' ? '#D3D3D3' : '' }}
                    {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} {t('routeoperation.of')} {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | {t("routeoperation.go")}{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              {t("routeoperation.show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}


function CancelledTrips() {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  const [cancelledTrips, setCancelledTrips] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: <p>{t('routeoperation.table1.route')}</p>,
        accessor: 'route_id',
        Cell: props => <div style={{ cursor: (dayjs(startDate).format('YYYY-MM-DD') == dayjs(endDate).format('YYYY-MM-DD')) ? 'pointer' : 'auto' }} onClick={(e) => handleRouteClick(e)}>{props.value}</div>,
      },
      {
        Header: <div>{t('canceltrips.table1.trips')}<br /><div>24h</div></div>,
        accessor: 'alltrips',
      },
      {
        Header: <div>{t('canceltrips.table1.cancelled')}<br /><div>24h</div></div>,
        accessor: 'cancelall',
      },
      {
        Header: <div>{t('canceltrips.table1.pct')}<br /><div>24h</div></div>,
        accessor: 'pctall',
        Cell: props => <div> {props.value > 0 ? parseFloat(props.value).toFixed(1) : 0}% </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('canceltrips.table1.trips')}<br /><div>AM</div></div>,
        accessor: 'alltripsam',
      },
      {
        Header: <div>{t('canceltrips.table1.cancelled')}<br /><div>AM</div></div>,
        accessor: 'cancelam',
      },
      {
        Header: <div>{t('canceltrips.table1.pct')}<br /><div>AM</div></div>,
        accessor: 'pctam',
        Cell: props => <div> {props.value > 0 ? parseFloat(props.value).toFixed(1) : 0}% </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('canceltrips.table1.trips')}<br /><div>PM</div></div>,
        accessor: 'alltripspm',
      },
      {
        Header: <div>{t('canceltrips.table1.cancelled')}<br /><div>PM</div></div>,
        accessor: 'cancelpm',
      },
      {
        Header: <div>{t('canceltrips.table1.pct')}<br /><div>PM</div></div>,
        accessor: 'pctpm',
        Cell: props => <div> {props.value > 0 ? parseFloat(props.value).toFixed(1) : 0}% </div>,
        sortType: "custom"
      }
    ],
    [cancelledTrips]
  )


  const [user, setUser] = useState('');
  const [agency, setAgency] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [userAgency, setUserAgency] = useState('');

  const [cancelledInt, setCancelledInt] = useState([]);

  const [route, setRoute] = useState('');

  const [tripClick, setTripClick] = useState('');

  const [loading, setLoading] = useState(0);

  const [initDate, setInitDate] = useState(dayjs().add(1, 'day').format('YYYY-MM-DD'));
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [startFormat, setStartFormat] = useState(dayjs().add(-30, 'day').format('YYYY-MM-DD'));
  const [endFormat, setEndFormat] = useState(dayjs().format('YYYY-MM-DD'));

  const [refreshKey, setRefreshKey] = useState(0);


  // Sans clé dans l'array, la fonction est exécutée 1 seule fois
  useEffect(() => {

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })


  }, []);


  useEffect(() => {

    getCancelledTrips(agency, startFormat, endFormat)
      .then(response => {
        setCancelledTrips(response);
      })


    getUserAgency()
      .then(res => {
        setUserAgency(res);
        setAgency(res[0]);
        let ag = res[0];

        getCancelledInt(ag, startFormat, endFormat)
          .then(response => {

            const parseAllR = [];

            response.forEach((e) => {

              let timezone = optc.optc.find((f) => { return f.operateur == ag }).timezone;

              let timeFormat = '';

              if (parseInt(e.timestr.substring(0, 2)) >= 0 && parseInt(e.timestr.substring(0, 2)) < 4) {
                timeFormat = (ag, e.timestr, dayjs("2019-04-28 " + e.timestr).add(1, 'day').tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
              } else {
                timeFormat = (ag, e.timestr, dayjs("2019-04-28 " + e.timestr).tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
              }

              let timeFormatTZ = dayjs(timeFormat).valueOf();

              parseAllR.push({
                time: timeFormatTZ,
                cancelled: e.count_per_range,
                agency: ag
              })
            })

            setCancelledInt(parseAllR);

          })

      })

  }, [refreshKey]);


  function handleRouteClick(e) {

    setRoute(e.target.innerHTML);
    setTripClick('');
    setShowTrips(true);

  }


  const handleAgencySelect = (e) => {
    setLoading(1);
    setAgency(e.target.value);
    setPlanTrips('');
    setTripClick('');
    setRefreshKey(oldKey => oldKey + 1);
  }


  const handleChangeDate = (dates) => {

    const [start, end] = dates;

    if (dayjs(start).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')) {
      setInitDate(dayjs().format('YYYY-MM-DD'));
    }

    setStartDate(start);
    setEndDate(end);
    setEndFormat('');


    if (end !== null) {

      //setDataType('planifie');

      let formatstart = dayjs(start).format('YYYY-MM-DD');
      let formatend = dayjs(end).format('YYYY-MM-DD');

      setRoute('');

      setStartFormat(formatstart);
      setEndFormat(formatend);
      setInitDate(dayjs().add(1, 'day').format('YYYY-MM-DD'));

      setRefreshKey(oldKey => oldKey + 1);
    }

  };

  const CustomTooltip = ({ active, payload }) => {
      if (active) {
        return (
          <div className="custom-tooltip">
            <p className="label">
              {t("home.chart.time")} : {dayjs(payload[0].payload.time).format('HH:mm:ss')}<br />
              {t("header.operations.canceltrips")} : {payload[0].payload.cancelled}</p>
          </div>
        );
      }
  
      return null;
    };


  return (
    user && userAgency && cancelledTrips.length > 0 ?
      <>
        <div className="row justify-content-center ps-1 pe-1">
          <div className="col-sm"></div>
          <h1 id="page-title" className="display-5">{t("canceltrips.title")}</h1>
          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          <div className="row text-center pt-3 pb-2">

            <DatePicker
              selected={startDate}
              onChange={handleChangeDate}
              locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
              inline
              startDate={startDate}
              endDate={endDate}
              selectsRange
              excludeDateIntervals={[
                {
                  start: new Date('2000-01-01'),
                  end: new Date('2023-07-01')
                },
                {
                  start: new Date(initDate),
                  end: new Date('2030-12-31')
                },
              ]}
            />

          </div>


          <div className="row justify-content-center">
            <div className="col-lg col-sm-12 text-center">

              {Array.isArray(userAgency) && userAgency.length > 1 ?
                <div className="me-1 border rounded ps-2 pe-2" style={{ backgroundColor: "white" }}>
                  <div className="row justify-content-center">
                    <div className="col-lg-4 col-sm-12">
                      <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                        <option defaultValue>Opérateur</option>
                        {userAgency.map((e) => (
                          <option value={e} key={e}
                          >{e}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div> : ''}

            </div>
          </div>


          <div className="row justify-content-center">
            <div className="col text-center pt-3">
              <h3>{(startFormat == endFormat || endFormat == '') ?
                dayjs(startDate).format('YYYY-MM-DD') :
                t("datatable.from") + ' ' + startFormat + ' ' + t("datatable.to") + ' ' + endFormat}</h3>
              {/* <h5 className="display-7">Inclus les départs après minuit</h5> */}
            </div>
          </div>

          <div className="row no-gutters align-items-center justify-content-center pb-3">
            <div className="col-12">
              <div className="border rounded" style={{ borderColor: "black", backgroundColor: "white" }}>
                <ResponsiveContainer width="100%" height={350}>
                  <ScatterChart width={730} height={250}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    data={cancelledInt}>
                    <XAxis
                      type="number"
                      dataKey="time"
                      name='time'
                      domain={[1556438400000, 1556521200000]}
                      tickFormatter={(unixTime) => dayjs(unixTime).format('HH:mm:ss')}
                      ticks={[
                        1556438400000,
                        1556442000000, 1556445600000, 1556449200000, 1556452800000,
                        1556456400000, 1556460000000, 1556463600000, 1556467200000,
                        1556470800000, 1556474400000, 1556478000000, 1556481600000,
                        1556485200000, 1556488800000, 1556492400000, 1556496000000,
                        1556499600000, 1556503200000, 1556506800000, 1556510400000,
                        1556514000000, 1556517600000, 1556521200000
                      ]}
                    />
                    <YAxis dataKey="cancelled" name={t("heard.operations.canceltrips")}
                      domain={[0, Math.max(...cancelledInt.map(o => o.cancelled))]} />
                    <ZAxis dataKey="z" range={[10]} />
                    <Legend formatter={(value, entry, index) =>
                      <span style={{ color: "black" }} className="text-color-class">{value}</span>
                    } />
                    <Tooltip
                      content={<CustomTooltip />}
                    />
                    <Scatter name={t("header.operations.canceltrips")} data={cancelledInt} fill='#4d0077' line shape="circle" />
                  </ScatterChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>


          <div className="col pt-2">
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div id="overflow-table" className="container">
                <div className="row justify-content-center">
                  <div className="col">
                    <Styles>
                      <Table columns={columns} data={cancelledTrips} />
                    </Styles>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {loading == 0 ? '' :
            <div className="routespinner">
              <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
            </div>}



        </div>
      </> :
      <>
        <div className="d-flex justify-content-center">
          <div className="row">
            <div className="col-sm">
              <h1 className="display-5">{t('data.loading')}</h1>
              <div className="d-flex justify-content-center">
                <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
              </div>
            </div>
          </div>
        </div>
      </>
  )
}

export default CancelledTrips